import { useMemo } from "react";

export const capitalizeFirstLetter = (str) => {
  if (!str) return "";
  return `${str.charAt(0).toUpperCase()}${str.slice(1).toLowerCase()}`;
};

export const useConfidenceClass = (confidence) => {
  return useMemo(() => {
    switch (confidence) {
      case "low":
        return "text-cm-text-tertiary";
      case "medium":
        return "text-cm-text-secondary";
      case "high":
        return "text-cm-accent";
      default:
        return "";
    }
  }, [confidence]);
};

export const getLocationString = (location, withZip = false) => {
  return location ? `${location.placeName}, ${location.stateCode}${withZip ? `, ${location.zip}` : ""}` : "";
};

export const getNumberWithCommas = (num, round) => {
  return new Intl.NumberFormat("en-US", { minimumFractionDigits: round ? 0 : 2, maximumFractionDigits: 2 }).format(
    round ? Math.round(num) : num,
  );
};

export const formatLocation = (city, state) => {
  if (!city || !state) return "";
  const formattedCity = city
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  const formattedState = state.toUpperCase();
  return `${formattedCity}, ${formattedState}`;
};

export const formatCurrency = (amount) => {
  if (!amount) return null;
  return `$${amount.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
};
